<template>
    <div style="height: 8px;">
        <div class="bg-yellow h-inherit" :style="'width:' + getWidth">
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    components: {},
    props: {
        currentStep: {
            type: Number
        },
        totalSteps: {
            type: Number
        }
    },
    computed: {
        getWidth() {
            var width = (this.currentStep / this.totalSteps) * 100;
            return width.toString() + '%;';
        }
    }
};
</script>
